import React from "react";

import { Header } from "components/Header";
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Dashboard from "views/Dashboard";
import Footer from "components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TablesPremiumLadder from "views/TablesPremiumLadder";
import TablesPensionPlan from "views/TablesPensionPlan";
import TablesExpenses from "views/TablesExpenses";
import TablesLifeCycle from "views/TablesLifeCycle";
import About from "views/About";

const App = () => {
  return (
    <>
       <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
      <Header />
      <main>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tables/life-cycle" element={<TablesLifeCycle />} />
            <Route path="/tables/premium-ladder" element={<TablesPremiumLadder />} />
            <Route path="/tables/expenses" element={<TablesExpenses />} />
            <Route path="/tables/pension-plan" element={<TablesPensionPlan />} />
            <Route path="/about" element={<About />} /> 
          </Routes>
      </main>
      <Footer />
    </>
  );
};

export default App;
